import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import React from "react";
import { T } from "services/lang/LanguageService";
import { DatasetScatterProps, YAxisIdentifier } from "../interfaces";

interface DatasetScatterChartRangesAndHighlightsEditorProps {
  config: DatasetScatterProps;
  onConfigChange: (config: DatasetScatterProps) => void;
  handleChange: (
    field: keyof DatasetScatterProps,
    value: string | string[] | number | boolean | null | YAxisIdentifier[]
  ) => void;
}

const DatasetScatterChartRangesAndHighlightsEditor = ({
  config,
  onConfigChange,
  handleChange,
}: DatasetScatterChartRangesAndHighlightsEditorProps) => {
  const handleAxisConfigChange = (
    field: "xRange" | "yRange",
    place: "from" | "to",
    value: number | null
  ) => {
    const range = config?.axisConfig?.[field] || [];
    range[place === "from" ? 0 : 1] = value!;
    onConfigChange({ ...config, axisConfig: { ...config?.axisConfig, [field]: range } });
  };

  return (
    <div className="grid p-fluid">
      <InputLabelWrapper labelName={T("label.scatter.x-axis-range")} col={3}>
        <div className="p-inputgroup">
          <InputNumber
            value={config?.axisConfig?.xRange?.[0]}
            onChange={e => handleAxisConfigChange("xRange", "from", e.value)}
            prefix="from "
            maxFractionDigits={5}
          />
          <InputNumber
            value={config?.axisConfig?.xRange?.[1]}
            onChange={e => handleAxisConfigChange("xRange", "to", e.value)}
            prefix="to "
            maxFractionDigits={5}
          />
        </div>
      </InputLabelWrapper>
      <InputLabelWrapper labelName={T("label.scatter.y-axis-range")} col={3}>
        <div className="p-inputgroup">
          <InputNumber
            value={config?.axisConfig?.yRange?.[0]}
            onChange={e => handleAxisConfigChange("yRange", "from", e.value)}
            prefix={`${T("word.from")} `}
            maxFractionDigits={5}
          />
          <InputNumber
            value={config?.axisConfig?.yRange?.[1]}
            onChange={e => handleAxisConfigChange("yRange", "to", e.value)}
            prefix={`${T("word.to")} `}
            maxFractionDigits={5}
          />
        </div>
      </InputLabelWrapper>
      <InputLabelWrapper labelName={T("label.scatter.highlight-count")} col={2}>
        <InputNumber
          value={config?.highlightCount}
          onChange={e => handleChange("highlightCount", e.value)}
          showButtons
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName={T("label.highlighted-values-description")} col={4}>
        <InputText
          value={config?.highlightedValuesDescription}
          onChange={e => handleChange("highlightedValuesDescription", e.target.value)}
        />
      </InputLabelWrapper>
    </div>
  );
};

export default DatasetScatterChartRangesAndHighlightsEditor;
